import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type User } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesUtente, validationSchemaUtente } from "./UtenteCommon"
import UtenteForm from "./UtenteForm"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateUtente } from "../../hooks/utenti"

export default function UtenteCreate() {
  const createUtente = useCreateUtente()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesUtente(), [])
  const validationSchema = useMemo(() => validationSchemaUtente(), [])

  useBreadcrumbs([{ label: "Utenti", href: "/utenti/utenti" }, { label: "Creazione Utente" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo utente</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createUtente.mutateAsync(values as User).then((user) => {
                navigate(`/utenti/utenti/${user.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <UtenteForm />
                </Container>
                <BottomFormFixed url="/utenti/utenti" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
